export function todayIso(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function isToday(iso: string): boolean {
  return iso === todayIso();
}

export function formatFrenchDate(iso: string): string {
  const d = new Date(`${iso}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  const diffDays = Math.round((d.getTime() - today.getTime()) / 86400000);
  if (diffDays === 0) return "Aujourd'hui";
  if (diffDays === 1) return 'Demain';
  if (diffDays === -1) return 'Hier';
  return new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: diffDays > 365 || diffDays < -365 ? 'numeric' : undefined,
  }).format(d);
}

export function formatFrenchDateShort(iso: string): string {
  const d = new Date(`${iso}T00:00:00`);
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(d);
}

/** « aujourd'hui », « hier », « il y a 3 j », « il y a 2 sem », « il y a 4 mois » */
export function formatRelativeFr(iso: string): string {
  const d = new Date(`${iso}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today.getTime() - d.getTime()) / 86400000);
  if (diffDays <= 0) return "aujourd'hui";
  if (diffDays === 1) return 'hier';
  if (diffDays < 7) return `il y a ${diffDays} j`;
  if (diffDays < 30) {
    const w = Math.floor(diffDays / 7);
    return `il y a ${w} sem`;
  }
  if (diffDays < 365) {
    const m = Math.floor(diffDays / 30);
    return `il y a ${m} mois`;
  }
  const y = Math.floor(diffDays / 365);
  return `il y a ${y} an${y > 1 ? 's' : ''}`;
}
